import { type ReactElement } from "react"
import getYourFans from "~/images/landing/get-your-fans.png"
import getYourFans2x from "~/images/landing/get-your-fans@2x.png"
import getYourFans3x from "~/images/landing/get-your-fans@3x.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

export function DesktopGetYourFansImage(): ReactElement {
  return (
    <div className="hidden md:block">
      <div className="relative">
        <ResponsiveImage
          sources={[
            { media: BREAKPOINTS.tablet, src: getYourFans2x },
            { media: BREAKPOINTS.desktop, src: getYourFans3x },
          ]}
          fallbackSrc={getYourFans}
          alt="Get your fans in the group chat"
          className=""
        />
      </div>
    </div>
  )
}
